import { render, staticRenderFns } from "./AttentionModal.vue?vue&type=template&id=98d12b60&scoped=true"
import script from "./AttentionModal.vue?vue&type=script&lang=js"
export * from "./AttentionModal.vue?vue&type=script&lang=js"
import style0 from "./AttentionModal.vue?vue&type=style&index=0&id=98d12b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d12b60",
  null
  
)

export default component.exports